import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/mdf/funds/:id/close
//
// Replaces /app/admin/mdf/_actions.ts::closeFundAction. Pessimistic with
// confirmation modal at the page layer (terminal status flip). Closing a
// fund rejects new partner requests against any of its allocations, so the
// portal-side `mdf.requests()` view also needs to refetch to surface the
// updated submission gate.
export function useCloseFund() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/mdf/funds/${id}/close`, {
        method: "POST",
      }),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.funds() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(id) });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      // Sub-bucket 15 — dashboard surfaces open-fund count + total budget.
      void queryClient.invalidateQueries({ queryKey: queryKeys.admin.dashboard() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to close fund");
    },
  });
}
